import(/* webpackMode: "eager", webpackExports: ["PageContact"] */ "/home/runner/work/Mitobyte/Mitobyte/src/app/contact/__page__/PageContact.tsx");
